import { render, staticRenderFns } from "./CustomTag.vue?vue&type=template&id=7fb439bd&scoped=true"
import script from "./CustomTag.vue?vue&type=script&lang=js"
export * from "./CustomTag.vue?vue&type=script&lang=js"
import style0 from "./CustomTag.vue?vue&type=style&index=0&id=7fb439bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb439bd",
  null
  
)

export default component.exports